import { TitleCasePipe, NgClass, AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { selectLogCount, selectLogError } from '../state/form.selectors';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-log',
  templateUrl: './log.component.html',
  providers: [TitleCasePipe],
  imports: [NgClass, AsyncPipe, TranslatePipe],
})
export class LogComponent {
  activeOffcanvas = inject(NgbActiveOffcanvas);
  private readonly titleCasePipe = inject(TitleCasePipe);
  private readonly store = inject(Store);

  logCount$ = this.store.select(selectLogCount);
  logError$ = this.store.select(selectLogError);
  icon = {
    information: 'fa-info-circle',
    warning: 'fa-triangle-exclamation',
    error: 'fa-exclamation-circle',
    fatal: 'fa-exclamation-circle',
  };

  getTitle(issue) {
    if (issue.code === 'not-supported') {
      return 'Unable to display the question item: ' + issue.diagnostics;
    } else if (issue.code === 'invalid') {
      return `Question item, ${issue.diagnostics}, contains an invalid display setting and may not display as expected.`;
    }
    return this.titleCasePipe.transform(issue.code);
  }

  getDescription(issue) {
    if (issue.code === 'not-supported') {
      return 'The display setting of the question item is currently not supported.';
    } else if (issue.code === 'invalid') {
      return 'Answer can be entered using the provided input field.';
    }
    return issue.diagnostics;
  }
}
